import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as BrandIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import Local from './components/Local';

/**
 * Component for displaying brand management.
 * @returns {React.JSX.Element} Brand management component
 */
function BrandManagement() {
  const { t } = useTranslation('deviceHub');
  const dispatch = useAppDispatch();
  const { totalResults: localTotal } = useAppSelector((state) => state.brand);

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('brands'),
        count: localTotal,
        icon: <BrandIcon />,
      }),
    );
  }, [dispatch, localTotal]);

  return (
    <div className="brand-management-wrap">
      <div className="brand-management-container">
        <div className="table-content">
          <Local />
        </div>
      </div>
    </div>
  );
}

export default BrandManagement;
